
import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { getAdminUrl } from '../utils/routingUtils';

const Footer = () => {
  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="container mx-auto px-6 py-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-lg font-semibold text-apple-text mb-4">True Talent Apply</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-apple-text-secondary hover:text-apple-blue transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-apple-text-secondary hover:text-apple-blue transition-colors">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-apple-text-secondary hover:text-apple-blue transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/enterprise" className="text-apple-text-secondary hover:text-apple-blue transition-colors">
                  Enterprise
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-apple-text mb-4">Job Seekers</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/jobs" className="text-apple-text-secondary hover:text-apple-blue transition-colors">
                  Browse Jobs
                </Link>
              </li>
              <li>
                <Link to="/signup" className="text-apple-text-secondary hover:text-apple-blue transition-colors">
                  Create Account
                </Link>
              </li>
              <li>
                <Link to="/tips" className="text-apple-text-secondary hover:text-apple-blue transition-colors">
                  Interview Tips
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-apple-text-secondary hover:text-apple-blue transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-apple-text mb-4">Employers</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/pricing" className="text-apple-text-secondary hover:text-apple-blue transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/employer-login" className="text-apple-text-secondary hover:text-apple-blue transition-colors">
                  Employer Login
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-apple-text-secondary hover:text-apple-blue transition-colors">
                  Contact Sales
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-apple-text mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/terms" className="text-apple-text-secondary hover:text-apple-blue transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-apple-text-secondary hover:text-apple-blue transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="text-apple-text-secondary hover:text-apple-blue transition-colors">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <a 
                  href="/admin"
                  className="text-apple-text-secondary hover:text-apple-blue transition-colors flex items-center gap-1"
                >
                  <ShieldCheck className="h-4 w-4" />
                  <span>Admin</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-200 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-apple-text-secondary text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} True Talent Apply. All rights reserved.
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-apple-text-secondary hover:text-apple-blue transition-colors">
              <span className="sr-only">Twitter</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
              </svg>
            </a>
            <a href="#" className="text-apple-text-secondary hover:text-apple-blue transition-colors">
              <span className="sr-only">LinkedIn</span>
              <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
